/// <reference path="../../typings/browser.d.ts" />
/// <reference path="../../customtypings/window.d.ts" />

/**
 * MiniSidebar service
 */
namespace Application.Services {
    'use strict';

    /**
     * MiniSidebarService
     */
    export class MiniSidebarService {
        
        public static $name: string = "miniSidebarService";
        public static $inject: string[] = ['$rootScope', '$cookies'];
        private static miniSidebarActiveCookieKey: string = "minisidebar_active";

        constructor(private $rootScope: IFlexRootScope,
                    private $cookies: ng.cookies.ICookiesService) {
            
        }
        
        public toggleSidebarMini(visible?: boolean): void {
            let sectionsLinks: JQuery = $('body.flex_theme #sidebar_main .menu_section > ul li');
            let currentSectionLink: JQuery = $('body.flex_theme #sidebar_main .menu_section > ul li.current_section');
            let subsectionList: JQuery = $('body.flex_theme #sidebar_main .menu_section > ul > li ul');
            
            sectionsLinks.removeClass('act_section');
            currentSectionLink.addClass('act_section');
            subsectionList.removeAttr('style');
            this.$rootScope.miniSidebarActive = visible !== undefined ? visible : !this.$rootScope.miniSidebarActive;

            if (!this.$rootScope.miniSidebarActive) {
                let currentSubsections: JQuery = $('body.flex_theme #sidebar_main .menu_section > ul > li.current_section ul');
                currentSubsections.attr('style', 'display:block');
            }

            if (visible === undefined)
                this.$cookies.put(MiniSidebarService.miniSidebarActiveCookieKey, this.$rootScope.miniSidebarActive.toString());

            this.$rootScope.$applyAsync();            
        }
    }
}